import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Col, Typography, Icon } from "witmeg-ui-system";
import "./Layout.scss"
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { getCurrencyFormat, getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import { addToCart, deleteCartItem, getCartItemsToCartV3, updateCartItemQuantity } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import deal from "../../assets/deal.png"
import deleteIc from "../../assets/trash.svg"

import DeletePopup from "../Cart/DeletePopup";
import { setOrderCartItems, setOrderData, setOrderEmpty } from '../../../../../../../redux/resturantWidgetSlice';
import CustomPopup from '../Cart/CustomPopup';
import { getTemplateData } from '../../../RestaurantWidget/utilities/api/voucherService';

import IMAGE_PLACEHOLDER from "../../assets/images/Images/vouchers-placeholder.jpg"
const Layout = ({ layout, setCartAlertVisible }) => {
    const [isDeleteItem, setIsDeleteItem] = useState("")
    const [isLoading, setIsLoading] = useState("")
    const [isIncreasing, setIsIncreasing] = useState(false)
    const [isDecreasing, setIsDeccreasing] = useState(false)
    const [isCustomOpen, setIsCustomOpen] = useState(false)
    const [templateData, setTemplateData] = useState([])



    const dispatch = useDispatch()
    const restaurantDataState = useSelector((state) => state.resturantData);
    const { menuData: { storage: { data } }, currency, menuData, orderCartData, voucherData
    } = useSelector((state) => state.resturantData);
    const { companyDetails } = useSelector((state) => state.companyData);
    const currencyFormat = getCurrencyFormat(currency);
    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price.DeliveryPrice;
                break;
            case "table":
                priceValue = price.TablePrice;
                break;
            default:
                priceValue = price.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };
    const findItemFromCart = (menuItem) => {
        let isAvailable = null
        if (!orderCartData?.Items) {
            return isAvailable
        }
        if (orderCartData?.Items?.length === 0) {
            return isAvailable
        }
        else {
            let found = orderCartData?.Items?.filter((item) => item.CartItemID === menuItem.MenuItemID)[0]
            isAvailable = found
        }
        return isAvailable

    }
    const updateTotalPrice = (price, quantity) => {
        const createPriceObj = (priceValue, quantity) => ({
            Amount: priceValue * quantity,
            FormattedText: currencyFormat((priceValue * quantity)),
            FormattedAmount: Number(((priceValue * quantity)).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });
        const totalPrice = getPriceData(price, quantity);
        return totalPrice
    }
    const increaseQty = (item) => {
        setIsIncreasing(true)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount + 1,
            "CountryISOCode": "GB"
        }
        const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
            itemValue.ID === item.ID
                ? {
                    ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount + 1 }, PriceInfo: {
                        ...itemValue.PriceInfo,
                        BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount + 1),
                        TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount + 1)

                    }
                }
                : itemValue
        );
        dispatch(setOrderCartItems(updatedArray))
        updateCartItemQuantity(data).then((response) => {
            dispatch(setOrderData(response))
            setIsIncreasing(false)
        })
    }
    const decreaseQty = (item) => {
        setIsDeccreasing(true)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount - 1,
            "CountryISOCode": "GB"
        }
        if (data.NewQuantity > 0) {
            const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
                itemValue.ID === item.ID
                    ? {
                        ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount - 1 }, PriceInfo: {
                            ...itemValue.PriceInfo,
                            BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount - 1),
                            TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount - 1),
                        }
                    }
                    : itemValue
            );
            dispatch(setOrderCartItems(updatedArray))
            updateCartItemQuantity(data).then((response) => {
                dispatch(setOrderData(response))
                setIsDeccreasing(false)

            })

        } else {
            let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== item.ID)
            dispatch(setOrderCartItems(cartArray))
            deleteCartItem(item.ID).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCartV3(customerID, cloud, "VOUCHER").then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    }
                    else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                    setIsDeccreasing(false)
                }
            })
        }
    }
    const deleteItem = () => {
        if (isDeleteItem !== "") {
            deleteCartItem(isDeleteItem).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCartV3(customerID, cloud, "VOUCHER").then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    } else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                }
            })
        }
    }
    const renderLayout1 = (menuItem) => {
        const item = findItemFromCart(menuItem)
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img alt="" src={menuItem?.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER} className="item-image" />
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}
                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className="name">{menuItem?.Title?.en?.toCapitalFirst()}</div>
                            <div className="price">
                                {getThePrice(menuItem?.PriceInfo?.Price)}
                            </div></div>

                        <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>
                    </div>
                </div>
                <div className="column-right-container">
                    <div className="column-right-container-inner">
                        {item ?
                            <div className="quantity">
                                <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                    if (!isDecreasing && !isIncreasing) {
                                        decreaseQty(item)
                                    }
                                }}>
                                    {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                </div>
                                <div className="qty-cont">
                                    {item?.Quantity.Amount || 0}
                                </div>

                                <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                    if (!isDecreasing && !isIncreasing) {
                                        increaseQty(item)
                                    }
                                }}>
                                    <Icon name="plus" className="icon" />
                                </div>
                            </div> : <div className="add-to-cart-btn" onClick={() => {
                                if (isLoading !== menuItem?.MenuItemID) {

                                    addItemToCart(menuItem)
                                }
                            }}>{isLoading === menuItem?.MenuItemID && <div className='loader-btn ' />}Add to cart</div>}

                    </div>
                </div>

            </div>
        )
    }
    const renderLayout2 = (menuItem) => {
        const item = findItemFromCart(menuItem)
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img style={{ objectFit: !menuItem?.ImageURL ? "fill" : "" }} alt="" src={menuItem?.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER} className="item-image"
                        />
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}

                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className="name">{menuItem?.Title?.en?.toCapitalFirst()}</div>
                            <div className="price">
                                {getThePrice(menuItem?.PriceInfo?.Price)}
                            </div></div>

                        <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>
                        <div className="price-container">
                            {item ?
                                <div className="quantity">
                                    <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing && !isIncreasing) {
                                            decreaseQty(item)
                                        }
                                    }}>
                                        {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                    </div>
                                    <div className="qty-cont">
                                        {item?.Quantity.Amount || 0}
                                    </div>

                                    <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing && !isIncreasing) {
                                            increaseQty(item)
                                        }
                                    }}>
                                        <Icon name="plus" className="icon" />
                                    </div>
                                </div> : <div className="add-to-cart-btn" onClick={() => {
                                    if (isLoading !== menuItem?.MenuItemID) {

                                        addItemToCart(menuItem)

                                    }
                                }}>{isLoading === menuItem?.MenuItemID && <div className='loader-btn ' />}Add to cart</div>}

                        </div>
                    </div>
                </div>

            </div>
        )
    }
    const renderLayout3 = (menuItem) => {
        const item = findItemFromCart(menuItem)
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img alt="" src={menuItem?.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER} className="item-image"
                        />
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}

                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className="name">{menuItem?.Title.en?.toCapitalFirst()}</div>
                            <div className="price">
                                {getThePrice(menuItem?.PriceInfo?.Price)}
                            </div></div>

                        <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>
                        <div className="price-container">
                            <div className="price">
                                {getThePrice(menuItem?.PriceInfo?.Price)}
                            </div>
                            {item ?
                                <div className="quantity">
                                    <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing && !isIncreasing) {
                                            decreaseQty(item)
                                        }
                                    }}>
                                        {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                    </div>
                                    <div className="qty-cont">
                                        {item?.Quantity.Amount || 0}
                                    </div>

                                    <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                        if (!isDecreasing && !isIncreasing) {
                                            increaseQty(item)
                                        }
                                    }}>
                                        <Icon name="plus" className="icon" />
                                    </div>
                                </div> : <div className="add-to-cart-btn" onClick={() => {
                                    if (isLoading !== menuItem?.MenuItemID) {

                                        addItemToCart(menuItem)

                                    }
                                }}>{isLoading === menuItem?.MenuItemID && <div className='loader-btn ' />}Add to cart</div>}

                        </div>
                    </div>
                </div>

            </div>
        )
    }
    const getLayout = (menuItem) => {
        let layoutComponent;

        switch (layout) {
            case "layout1":
                layoutComponent = renderLayout1(menuItem);
                break;

            case "layout2":
                layoutComponent = renderLayout2(menuItem);
                break;
            case "layout3":
                layoutComponent = renderLayout3(menuItem);
                break;
            default:
                layoutComponent = renderLayout1(menuItem);
                break;
        }

        return layoutComponent;
    };
    const getOrderType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
            case "table":
                type = "DINE_IN";
                break;
            case "collection":
                type = "TAKE_AWAY";
                break;
            default:
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
        }
        return type
    }
    const getItemPriceForCart = (option, quantity) => {
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: "GB"
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);
        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const addItemToCart = async (selectedItem) => {
        let itemsAvailable = restaurantDataState.orderCartData?.Items?.some(itemVal => itemVal.MetaData === null) ?? false;
        if (!itemsAvailable) {
            setIsLoading(selectedItem.MenuItemID)
            const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
            const userDetails = localStorage.getItem('fullUserDetails')
            let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
            let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
            let customer = {
                ID: customerID,
                Name: {
                    DisplayName: userDetails ? parsedUserDetails.UserName : "",
                    FirstName: userDetails ? parsedUserDetails.FirstName : "",
                    LastName: userDetails ? parsedUserDetails.LastName : "",
                },
                Email: userDetails ? parsedUserDetails.Email : "",
                IsPrimaryCustomer: true

            }
            let cartObject = {
                "CartItemID": selectedItem.MenuItemID,
                "Title": selectedItem.Title?.en,
                "CustomerID": customerID,
                "Quantity": {
                    "Unit": "pcs",
                    "Amount": 1
                },
                "DefaultQuantity": {
                    "Amount": 1,
                    "Unit": "pcs"
                },
                "CustomerRequests": {
                    "Allergy": {
                        "Allergens": [],
                        "Instructions": ""
                    },
                    "SpecialInstructions": ""
                },
                SelectedModifierGroups: [],
                Id: uuidv4(),
                ID: "",
                ModifierGroupRules: selectedItem.ModifierGroupRules,
                Image: selectedItem.ImageURL,
                PriceInfo: getItemPriceForCart(selectedItem.PriceInfo, 1),
                MetaData: {
                    IsVoucher: true,
                    Type: "STANDARD",
                    TemplateID: "",
                    ExpiryDate: "",
                    ProductID: selectedItem?.MetaData?.ProductID
                }

            }
            let cart = {
                "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : '',
                "StoreID": val.cloudLocationID,
                "ConsumerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                "OrderingPlatformType": "RETAILPACX",
                "CountryISOCode": "GB",
                "OrganizationID": val.organizationID,
                "CloudLocationID": val.cloudLocationID,
                "Name": companyDetails.shopName,
                "OrderFullFilmentType": getOrderType(),
                "Customers": [customer],
                Cart: cartObject,
                OrderType: "VOUCHER"
            }
            await addToCart(cart).then((res) => {
                if (res) {
                    getCartItemsToCartV3(customerID, val.cloudLocationID, "VOUCHER").then((response) => {
                        if (response) {
                            dispatch(setOrderData(response))
                            setIsLoading("")

                        }
                    })
                }
            })
        }
        else {
            setCartAlertVisible(true)
        }
    }
    useEffect(() => {
        getData()
    }, [])
    const getData = async () => {
        const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
        let valueDate = await getTemplateData(val.cloudLocationID)
        if (valueDate) {
            setTemplateData(valueDate)
        }
    }
    useEffect(() => {
        if (data?.Categories?.length > 0) {
            const filteredItems = [];

            data.Categories.forEach((category) => {
                category.MenuEntities.forEach((menuEntity) => {
                    const menuItem = _.find(menuData?.storage?.data?.Items, { MenuItemID: menuEntity.ID });

                    if (menuItem?.MetaData?.CustomVoucher) {
                        filteredItems.push(menuItem);
                    }
                });
            });
            if (filteredItems.length > 0) {
                localStorage.setItem("ECOM_CUSTOM", JSON.stringify(filteredItems[0]))
            }
        }
    }, [data]);
    return (
        <div className="Voucher-navbar-Layout">
            {
                voucherData?.Settings?.CustomVoucher?.Enable && <div>
                    <Typography type="title" level={4} pattern="bold" className="title-vouchers" >Custom Vouchers</Typography>
                    <Typography className="sub-title-vouchers" >Personalize your gift voucher</Typography>
                    <div className='empty-voucer-container' onClick={() => {
                        setIsCustomOpen(true)
                    }}>
                        <div>
                            <div className='icon-add'>
                                <div className="icon">+</div>
                            </div>
                            <div className='text'>Create your own Voucher</div>
                        </div>
                    </div>

                </div>}
            <Typography type="title" level={4} pattern="bold" className="title-vouchers" >Standard Vouchers</Typography>
            <Typography className="sub-title-vouchers" >Choose from our predefined gift voucher options</Typography>


            {data.Categories && data.Categories.length > 0 ? data.Categories.map((data, index) => {
                return (
                    <div key={index} style={{ marginBottom: "20px" }}>
                        <div className={layout}>
                            {data.MenuEntities.map(((menuEntity, key) => {
                                const menuItem = _.find(menuData.storage.data.Items, { MenuItemID: menuEntity.ID });
                                if (!menuItem?.MetaData?.CustomVoucher) {
                                    return (
                                        <div className="column-styles" key={key}>
                                            {getLayout(menuItem)}
                                        </div>
                                    )
                                }
                            }))}
                        </div>
                    </div>
                )
            }) : <div className='empty-cont'>Vouchers not available</div>}

            <DeletePopup
                visibility={isDeleteItem !== ""}
                onPopupClose={() => {
                    setIsDeleteItem("")
                }}
                onDeleteConfirm={deleteItem} />
            <CustomPopup visibility={isCustomOpen}
                onPopupClose={() => {
                    setIsCustomOpen(false)
                }}
                Data={templateData}
                setCartAlertVisible={setCartAlertVisible} />
        </div >
    )
}
export default Layout